import moment from "moment"

export const parseToMoment = (date: string | number | Date | null) => {
  return moment(date, 'YYYY-MM-DD')
}

export const parseToDate = (date: string | number | Date | null) => {
  return parseToMoment(date).toDate()
}

export const tryParseToDateOrUndefined = (date: string | number | Date | null) => {
  const parsedDate = parseToDate(date)
  if (parsedDate.toDateString() !== 'Invalid Date') {
    return parsedDate
  }
  return undefined
}
